/*
 * GWE Motion Core v5
 *
 * One Lenis instance for the storefront, synchronized with ScrollTrigger.
 * Kept intentionally close to the setup used by the Codrops reference.
 */

(() => {
  if (window.GWEMotion?.ready) return;

  const boot = () => {
    if (!window.gsap || !window.ScrollTrigger || !window.Lenis) {
      window.setTimeout(boot, 40);
      return;
    }

    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    const Lenis = window.Lenis;

    gsap.registerPlugin(ScrollTrigger);

    let lenis = window.__gweLenis;

    if (!lenis) {
      lenis = new Lenis({
        lerp: 0.08,
        wheelMultiplier: 1.4,
        smoothWheel: true,
        syncTouch: false,
        autoRaf: false,
        anchors: true,
        autoResize: true
      });

      lenis.on('scroll', ScrollTrigger.update);

      gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
      });

      gsap.ticker.lagSmoothing(0);

      window.__gweLenis = lenis;
    }

    window.GWEMotion = {
      ready: true,
      gsap,
      ScrollTrigger,
      Lenis,
      lenis,
      refresh() {
        ScrollTrigger.refresh();
      }
    };

    document.documentElement.classList.add('gwe-motion-ready');
    window.dispatchEvent(new CustomEvent('gwe:motion-ready'));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, {
      once: true
    });
  } else {
    boot();
  }
})();
